import { render } from "./OverzichtHome.vue?vue&type=template&id=3656aa70&scoped=true"
import script from "./OverzichtHome.vue?vue&type=script&lang=js"
export * from "./OverzichtHome.vue?vue&type=script&lang=js"

import "./OverzichtHome.vue?vue&type=style&index=0&id=3656aa70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3656aa70"]])

export default __exports__